<template>
<div class="ti">
  <div style="margin-bottom:15px">
    <el-select size="mini" v-model="pid" filterable placeholder="请选项目" class="">
      <el-option
        v-for="item in projectList"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <!-- <el-select v-model="chargeitemID" filterable placeholder="费用类型" class="">
      <el-option
        key=""
        label="全部费用"
        value="">
      </el-option>
      <el-option
        v-for="item in chargeitem"
        :key="item.id"
        :label="item.chargeItem_name"
        :value="item.id">
      </el-option>
    </el-select> -->
    <el-date-picker size="mini"
      v-model="datevalue"
      type="month"
      placeholder="选择月">
    </el-date-picker>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <div style="display: flex;color: red;">
    <div>总金额：￥{{totalMoney}}元</div>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">日期</th>
            <th class="text-left">金额</th>
          </tr>
        </thead>
        <!-- 撤销 -->
        <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <tr class="text1" v-for="(item, index) in data" v-if="(Math.floor(index / pageSize) + 1) == page" :key="item.month">
            <td>{{ item.month }}</td>
            <td>{{ item.momey }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="data">
      <Page :total="total" :page-size="pageSize" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
</div>

</template>

<script>

export default {
  name: 'FinanceReport',
  data () {
    return {
      projectList: [],
      pid: '',
      chargeitem: [],
      chargeitemID: '',
      datevalue: '',
      loading: false,
      data: [],
      total: 0,
      pageSize: 10,
      page: 1,
      treeValue: '',
      totalMoney: 0,
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){

    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.projectList = backdata.data.data;
    });

    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    searchs() {

      this.loading = true
      let month =this.datevalue ? new Date(this.datevalue).getTime() / 1000 : ''

      this.$myhttp.get(`admin/Order/getStatements?month=${month}&precinctid=${this.pid}`,{
        'Content-Type': 'application/json'
      }).then(backdata=>{
        this.loading = false
        if(backdata.data.code == 200) {
          this.totalMoney = backdata.data.data[0].momey
          this.data = backdata.data.data.splice(1)
          this.total = this.data.length
          let pageCount = Math.ceil(this.total / this.pageSize)
          if(this.page > pageCount) this.page = pageCount
        } else {
          this.totalMoney = 0
          this.data = []
          this.total = 0
          this.page = 1
        }

      });

    },
    //获得当前多少页,分页
    change(e){
      this.page = e
    },
  },
  watch:{

  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/financeReport.vue